<template>
  <div class="privatstep1">

        <base-data state-path="b"/>

        <v-row no-gutters class="stepperbuttons">
          <v-spacer/>
          <v-btn id="next1"
                 color="primary"
                 class="standard-button"
                 @click="$emit('step-forward')">Weiter</v-btn>
        </v-row>

  </div>
</template>

<script>
import BaseData from "@/components/privatkundenrechner/BaseData";
import { INIT_PRAEMIEN} from "@/store/actionTypes";

export default {
  name: "PrivatStep1",
  components: { BaseData },
  mounted: function()  {
    this.$store.dispatch(INIT_PRAEMIEN, this.$store.getters.tarifToLoad);
  }
};
</script>
